import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { DiningService } from '../services/dining.service';
import type {
  DiningReservationListParams,
  CreateDiningReservationDto,
} from '../services/dining.service';

export const diningKeys = {
  all: ['dining'] as const,
  data: () => [...diningKeys.all, 'data'] as const,
  outlets: () => [...diningKeys.all, 'outlets'] as const,
  reservations: () => [...diningKeys.all, 'reservations'] as const,
  reservationList: (params?: DiningReservationListParams) =>
    [...diningKeys.reservations(), params] as const,
} as const;

export function useDiningData() {
  return useQuery({
    queryKey: diningKeys.data(),
    queryFn: () => DiningService.getData(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useDiningOutlets() {
  return useQuery({
    queryKey: diningKeys.outlets(),
    queryFn: () => DiningService.listOutlets(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useDiningReservations(params?: DiningReservationListParams) {
  return useQuery({
    queryKey: diningKeys.reservationList(params),
    queryFn: () => DiningService.listReservations(params),
    staleTime: 2 * 60 * 1000,
  });
}

export function useCreateDiningReservation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (dto: CreateDiningReservationDto) => DiningService.createReservation(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: diningKeys.reservations() });
    },
  });
}
